export const chapters = [
    {
        "number": 1,
        "name": "கடவுள் வாழ்த்து"
    },
    {
        "number": 2,
        "name": "வான்சிறப்பு"
    },
    {
        "number": 3,
        "name": "நீத்தார் பெருமை"
    },
    {
        "number": 4,
        "name": "அறன் வலியுறுத்தல்"
    },
    {
        "number": 5,
        "name": "இல்வாழ்க்கை"
    },
    {
        "number": 6,
        "name": "வாழ்க்கைத் துணைநலம்"
    },
    {
        "number": 7,
        "name": "புதல்வரைப் பெறுதல்"
    },
    {
        "number": 8,
        "name": "அன்புடைமை"
    },
    {
        "number": 9,
        "name": "விருந்தோம்பல்"
    },
    {
        "number": 10,
        "name": "இனியவைகூறல்"
    },
    {
        "number": 11,
        "name": "செய்ந்நன்றி அறிதல்"
    },
    {
        "number": 12,
        "name": "நடுவு நிலைமை"
    },
    {
        "number": 13,
        "name": "அடக்கமுடைமை"
    },
    {
        "number": 14,
        "name": "ஒழுக்கமுடைமை"
    },
    {
        "number": 15,
        "name": "பிறனில் விழையாமை"
    },
    {
        "number": 16,
        "name": "பொறையுடைமை"
    },
    {
        "number": 17,
        "name": "அழுக்காறாமை"
    },
    {
        "number": 18,
        "name": "வெஃகாமை"
    },
    {
        "number": 19,
        "name": "புறங்கூறாமை"
    },
    {
        "number": 20,
        "name": "பயனில சொல்லாமை"
    },
    {
        "number": 21,
        "name": "தீவினையச்சம்"
    },
    {
        "number": 22,
        "name": "ஒப்புரவறிதல்"
    },
    {
        "number": 23,
        "name": "ஈகை"
    },
    {
        "number": 24,
        "name": "புகழ்"
    },
    {
        "number": 25,
        "name": "அருளுடைமை"
    },
    {
        "number": 26,
        "name": "புலான்மறுத்தல்"
    },
    {
        "number": 27,
        "name": "தவம்"
    },
    {
        "number": 28,
        "name": "கூடாவொழுக்கம்"
    },
    {
        "number": 29,
        "name": "கள்ளாமை"
    },
    {
        "number": 30,
        "name": "வாய்மை"
    },
    {
        "number": 31,
        "name": "வெகுளாமை"
    },
    {
        "number": 32,
        "name": "இன்னாசெய்யாமை"
    },
    {
        "number": 33,
        "name": "கொல்லாமை"
    },
    {
        "number": 34,
        "name": "நிலையாமை"
    },
    {
        "number": 35,
        "name": "துறவு"
    },
    {
        "number": 36,
        "name": "மெய்யுணர்தல்"
    },
    {
        "number": 37,
        "name": "அவாவறுத்தல்"
    },
    {
        "number": 38,
        "name": "ஊழ்"
    },
    {
        "number": 39,
        "name": "இறைமாட்சி"
    },
    {
        "number": 40,
        "name": "கல்வி"
    },
    {
        "number": 41,
        "name": "கல்லாமை"
    },
    {
        "number": 42,
        "name": "கேள்வி"
    },
    {
        "number": 43,
        "name": "அறிவுடைமை"
    },
    {
        "number": 44,
        "name": "குற்றங்கடிதல்"
    },
    {
        "number": 45,
        "name": "பெரியாரைத் துணைக்கோடல்"
    },
    {
        "number": 46,
        "name": "சிற்றினஞ்சேராமை"
    },
    {
        "number": 47,
        "name": "தெரிந்துசெயல்வகை"
    },
    {
        "number": 48,
        "name": "வலியறிதல்"
    },
    {
        "number": 49,
        "name": "காலமறிதல்"
    },
    {
        "number": 50,
        "name": "இடனறிதல்"
    },
    {
        "number": 51,
        "name": "தெரிந்துதெளிதல்"
    },
    {
        "number": 52,
        "name": "தெரிந்துவினையாடல்"
    },
    {
        "number": 53,
        "name": "சுற்றந்தழால்"
    },
    {
        "number": 54,
        "name": "பொச்சாவாமை"
    },
    {
        "number": 55,
        "name": "செங்கோன்மை"
    },
    {
        "number": 56,
        "name": "கொடுங்கோன்மை"
    },
    {
        "number": 57,
        "name": "வெருவந்தசெய்யாமை"
    },
    {
        "number": 58,
        "name": "கண்ணோட்டம்"
    },
    {
        "number": 59,
        "name": "ஒற்றாடல்"
    },
    {
        "number": 60,
        "name": "ஊக்கமுடைமை"
    },
    {
        "number": 61,
        "name": "மடியின்மை"
    },
    {
        "number": 62,
        "name": "ஆள்வினையுடைமை"
    },
    {
        "number": 63,
        "name": "இடுக்கணழியாமை"
    },
    {
        "number": 64,
        "name": "அமைச்சு"
    },
    {
        "number": 65,
        "name": "சொல்வன்மை"
    },
    {
        "number": 66,
        "name": "வினைத்தூய்மை"
    },
    {
        "number": 67,
        "name": "வினைத்திட்பம்"
    },
    {
        "number": 68,
        "name": "வினைசெயல்வகை"
    },
    {
        "number": 69,
        "name": "தூது"
    },
    {
        "number": 70,
        "name": "மன்னரைச் சேர்ந்தொழுதல்"
    },
    {
        "number": 71,
        "name": "குறிப்பறிதல்"
    },
    {
        "number": 72,
        "name": "அவையறிதல்"
    },
    {
        "number": 73,
        "name": "அவையஞ்சாமை"
    },
    {
        "number": 74,
        "name": "நாடு"
    },
    {
        "number": 75,
        "name": "அரண்"
    },
    {
        "number": 76,
        "name": "பொருள்செயல்வகை"
    },
    {
        "number": 77,
        "name": "படைமாட்சி"
    },
    {
        "number": 78,
        "name": "படைச்செருக்கு"
    },
    {
        "number": 79,
        "name": "நட்பு"
    },
    {
        "number": 80,
        "name": "நட்பாராய்தல்"
    },
    {
        "number": 81,
        "name": "பழைமை"
    },
    {
        "number": 82,
        "name": "தீ நட்பு"
    },
    {
        "number": 83,
        "name": "கூடாநட்பு"
    },
    {
        "number": 84,
        "name": "பேதைமை"
    },
    {
        "number": 85,
        "name": "புல்லறிவாண்மை"
    },
    {
        "number": 86,
        "name": "இகல்"
    },
    {
        "number": 87,
        "name": "பகைமாட்சி"
    },
    {
        "number": 88,
        "name": "பகைத்திறந்தெரிதல்"
    },
    {
        "number": 89,
        "name": "உட்பகை"
    },
    {
        "number": 90,
        "name": "பெரியாரைப் பிழையாமை"
    },
    {
        "number": 91,
        "name": "பெண்வழிச்சேறல்"
    },
    {
        "number": 92,
        "name": "வரைவின்மகளிர்"
    },
    {
        "number": 93,
        "name": "கள்ளுண்ணாமை"
    },
    {
        "number": 94,
        "name": "சூது"
    },
    {
        "number": 95,
        "name": "மருந்து"
    },
    {
        "number": 96,
        "name": "குடிமை"
    },
    {
        "number": 97,
        "name": "மானம்"
    },
    {
        "number": 98,
        "name": "பெருமை"
    },
    {
        "number": 99,
        "name": "சான்றாண்மை"
    },
    {
        "number": 100,
        "name": "பண்புடைமை"
    },
    {
        "number": 101,
        "name": "நன்றியில்செல்வம்"
    },
    {
        "number": 102,
        "name": "நாணுடைமை"
    },
    {
        "number": 103,
        "name": "குடிசெயல்வகை"
    },
    {
        "number": 104,
        "name": "உழவு"
    },
    {
        "number": 105,
        "name": "நல்குரவு"
    },
    {
        "number": 106,
        "name": "இரவு"
    },
    {
        "number": 107,
        "name": "இரவச்சம்"
    },
    {
        "number": 108,
        "name": "கயமை"
    },
    {
        "number": 109,
        "name": "தகையணங்குறுத்தல்"
    },
    {
        "number": 110,
        "name": "குறிப்பறிதல்"
    },
    {
        "number": 111,
        "name": "புணர்ச்சிமகிழ்தல்"
    },
    {
        "number": 112,
        "name": "நலம்புனைந்துரைத்தல்"
    },
    {
        "number": 113,
        "name": "காதற்சிறப்புரைத்தல்"
    },
    {
        "number": 114,
        "name": "நாணுத்துறவுரைத்தல்"
    },
    {
        "number": 115,
        "name": "அலரறிவுறுத்தல்"
    },
    {
        "number": 116,
        "name": "பிரிவாற்றாமை"
    },
    {
        "number": 117,
        "name": "படர்மெலிந்திரங்கல்"
    },
    {
        "number": 118,
        "name": "கண்விதுப்பழிதல்"
    },
    {
        "number": 119,
        "name": "பசப்புறுபருவரல்"
    },
    {
        "number": 120,
        "name": "தனிப்படர்மிகுதி"
    },
    {
        "number": 121,
        "name": "நினைந்தவர்புலம்பல்"
    },
    {
        "number": 122,
        "name": "கனவுநிலையுரைத்தல்"
    },
    {
        "number": 123,
        "name": "பொழுதுகண்டிரங்கல்"
    },
    {
        "number": 124,
        "name": "உறுப்புநலனழிதல்"
    },
    {
        "number": 125,
        "name": "நெஞ்சொடுகிளத்தல்"
    },
    {
        "number": 126,
        "name": "நிறையழிதல்"
    },
    {
        "number": 127,
        "name": "அவர்வயின்விதும்பல்"
    },
    {
        "number": 128,
        "name": "குறிப்பறிவுறுத்தல்"
    },
    {
        "number": 129,
        "name": "புணர்ச்சிவிதும்பல்"
    },
    {
        "number": 130,
        "name": "நெஞ்சொடுபுலத்தல்"
    },
    {
        "number": 131,
        "name": "புலவி"
    },
    {
        "number": 132,
        "name": "புலவி நுணுக்கம்"
    },
    {
        "number": 133,
        "name": "ஊடலுவகை"
    }
]